/**
 * 「監視・措置」tab of the staff console (spec: content-moderation-controls).
 * ADMIN and MANAGER see monitoring, image review and per-streamer actions;
 * NG words and the action log are ADMIN-only.
 */
import { useState } from 'react';
import LiveMonitorPanel from './LiveMonitorPanel';
import MediaReviewPanel from './MediaReviewPanel';
import ModerationActionsPanel from './ModerationActionsPanel';
import NgWordManagementPanel from './NgWordManagementPanel';
import StreamerModerationPanel from './StreamerModerationPanel';

type ModerationTab = 'monitor' | 'media' | 'streamers' | 'ngwords' | 'actions';

interface ModerationConsoleProps {
  isAdmin: boolean;
}

const TABS: { id: ModerationTab; label: string; adminOnly: boolean }[] = [
  { id: 'monitor', label: '配信監視', adminOnly: false },
  { id: 'media', label: '画像承認', adminOnly: false },
  { id: 'streamers', label: '配信者の措置', adminOnly: false },
  { id: 'ngwords', label: 'NGワード', adminOnly: true },
  { id: 'actions', label: '措置記録・月次レポート', adminOnly: true },
];

export default function ModerationConsole({ isAdmin }: ModerationConsoleProps) {
  const [tab, setTab] = useState<ModerationTab>('monitor');
  const visibleTabs = TABS.filter((item) => isAdmin || !item.adminOnly);

  return (
    <div className="p-6 text-left">
      <nav className="mb-6 flex flex-wrap gap-2" aria-label="監視・措置メニュー">
        {visibleTabs.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setTab(item.id)}
            aria-current={tab === item.id ? 'page' : undefined}
            className={`px-4 py-1.5 text-sm font-semibold ${tab === item.id ? 'bg-red-700 text-white' : 'border border-gray-300 bg-white text-gray-700'}`}
          >
            {item.label}
          </button>
        ))}
      </nav>
      {tab === 'monitor' && <LiveMonitorPanel isAdmin={isAdmin} />}
      {tab === 'media' && <MediaReviewPanel />}
      {tab === 'streamers' && <StreamerModerationPanel isAdmin={isAdmin} />}
      {tab === 'ngwords' && isAdmin && <NgWordManagementPanel />}
      {tab === 'actions' && isAdmin && <ModerationActionsPanel />}
    </div>
  );
}
